<template>
  <v-container fluid>
    <log-entries-table />
  </v-container>
</template>

<script>
import LogEntriesTable from '@/components/LogEntriesTable.vue';

export default {
  name: 'LogEntriesPage',
  components: {
    LogEntriesTable,
  },
};
</script>

<style scoped>
</style>
